import {createApp} from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import 'ant-design-vue/dist/reset.css';
import router from './router';

const app = createApp(App);

// 全局监听路由变化（在路由实例化后配置）
router.beforeEach((to, from, next) => {
    // 从目标路由的 meta 字段中获取标题
    document.title = to.meta.title || 'Surprise benefits';
    next(); // 继续导航
});

app.use(router);
app.use(Antd);

app.mount('#app');
